//#region Util Imports

import * as _ from 'underscore'

//#endregion

//#region Helper Imports

import { TemplateHelper, ConfigHelper, LocalizationHelper } from "../../helpers"

//#endregion

//#region Model Imports

import { Activity, Enums } from "../../models/common"

//#endregion

//#region Service Imports 

import { USER_SESSION_SERVICE_NAME, UserSessionService } from "../user-session"
import { SystemContextListService, SYSTEM_CONTEXT_LIST_SERVICE_NAME } from "../system"

//#endregion


//#region Public Types

export const LOCATION_CONTEXT_MENU_SERVICE_NAME = 'locationContextMenuService'
export const LOCATION_CONTEXT_MENU_SERVICE_PROVIDER_NAME = 'locationContextMenuServiceProvider'

export type IdLocationGridContextMenuOptions = {
    idReferenceTypes?: number[]
    onEdit?: () => void
    onCopy?: () => void
    getCorrespondingActionType?: (idReferenceType: Enums.ReferenceType, args: any) => void
    getLocationsProblems?: () => void
    planDelivery?: () => void
    onMassGroupingLocationAssign?: (args: any) => void
    onLocationSchemaAssign?: () => void
}

//#endregion

export class LocationContextMenuService {

    // #region Ctor

    public constructor(
        private readonly systemContextListService: SystemContextListService,
        private readonly userSessionService: UserSessionService
    ) { }

    // #endregion


    // #region Public Methods

    public getContextMenuItems(options: IdLocationGridContextMenuOptions): any[] {
        const items: { beginGroup?: boolean, template: string, onItemClick: (args: any) => void }[] = []

        if (options == null) {
            return items
        }


        if (options.onEdit != null && this.userSessionService.getLoggedOperator().hasPermission(Activity.LOCATION_EDIT)) {
            items.push({
                beginGroup: true,
                template: TemplateHelper.getContextMenuItem(LocalizationHelper.getLocalizedText(LocalizationHelper.Text.Edit), ConfigHelper.Icon.EDIT, this.userSessionService),

                onItemClick: () => {
                    options.onEdit()
                },
            })
        }

        if (options.onCopy != null
            && _.size(options.idReferenceTypes) === 1
            && this.userSessionService.getLoggedOperator().hasPermission(Activity.LOCATION_COPY)) {
            items.push({
                template: TemplateHelper.getContextMenuItem(LocalizationHelper.getLocalizedText(LocalizationHelper.Text.Copy), ConfigHelper.Icon.CONTENT_COPY, this.userSessionService),

                onItemClick: () => {
                    options.onCopy()
                },
            })
        }

        if (options.onLocationSchemaAssign != null && this.userSessionService.getLoggedOperator().hasPermission(Activity.SCHEMA_EDIT)) {
            items.push({
                template: TemplateHelper.getContextMenuItem(LocalizationHelper.getLocalizedText(LocalizationHelper.Text.AssignRemoveLocationSchema), ConfigHelper.Icon.VIEW_CAROUSEL, this.userSessionService),

                onItemClick: () => {
                    options.onLocationSchemaAssign()
                },
            })
        }

        if (options.idReferenceTypes != null) {
            if (this.userSessionService.getLoggedOperator().hasPermission(Activity.DEVICE_LIST)
                && !this.userSessionService.getLoggedOperator().hasPermission(Activity.DEVICE_MODULE_HIDDEN_UI_OBJECT_PROPERTIES, Enums.UIObjectProperties.DeviceModule)) {
                items.push({
                    beginGroup: true,
                    template: TemplateHelper.getContextMenuItem(LocalizationHelper.getLocalizedText(LocalizationHelper.Text.ShowDevices), ConfigHelper.Icon.DEVICES, this.userSessionService),

                    onItemClick: () => {
                        this.systemContextListService.getContextList(Enums.ReferenceType.SerialNbr, options.idReferenceTypes, Enums.ReferenceType.IdLocation)
                    }
                })
            }

            if (this.userSessionService.getLoggedOperator().hasPermission(Activity.METER_LIST)
                && !this.userSessionService.getLoggedOperator().hasPermission(Activity.METER_MODULE_HIDDEN_UI_OBJECT_PROPERTIES, Enums.UIObjectProperties.MeterModule)) {
                items.push({
                    template: TemplateHelper.getContextMenuItem(LocalizationHelper.getLocalizedText(LocalizationHelper.Text.ShowMeters), ConfigHelper.Icon.METERS, this.userSessionService),

                    onItemClick: () => {
                        this.systemContextListService.getContextList(Enums.ReferenceType.IdMeter, options.idReferenceTypes, Enums.ReferenceType.IdLocation)
                    }
                })
            }

            if (this.userSessionService.getLoggedOperator().hasPermission(Activity.TASK_LIST)
                && !this.userSessionService.getLoggedOperator().hasPermission(Activity.TASK_MODULE_HIDDEN_UI_OBJECT_PROPERTIES, Enums.UIObjectProperties.TaskModule)) {
                items.push({
                    template: TemplateHelper.getContextMenuItem(LocalizationHelper.getLocalizedText(LocalizationHelper.Text.ShowTasks), ConfigHelper.Icon.TASKS, this.userSessionService),

                    onItemClick: () => {
                        this.systemContextListService.getContextList(Enums.ReferenceType.IdTask, options.idReferenceTypes, Enums.ReferenceType.IdLocation)
                    }
                })
            }

            if (this.userSessionService.getLoggedOperator().hasPermission(Activity.ISSUE_LIST)
                && !this.userSessionService.getLoggedOperator().hasPermission(Activity.ISSUE_MODULE_HIDDEN_UI_OBJECT_PROPERTIES, Enums.UIObjectProperties.IssueMoodule)) {
                items.push({
                    template: TemplateHelper.getContextMenuItem(LocalizationHelper.getLocalizedText(LocalizationHelper.Text.ShowIssues), ConfigHelper.Icon.ISSUES, this.userSessionService),

                    onItemClick: () => {
                        this.systemContextListService.getContextList(Enums.ReferenceType.IdIssue, options.idReferenceTypes, Enums.ReferenceType.IdLocation)
                    }
                })
            }

            if (this.userSessionService.getLoggedOperator().hasPermission(Activity.SIM_CARD_LIST)
                && !this.userSessionService.getLoggedOperator().hasPermission(Activity.SIM_CARD_MODULE_HIDDEN_UI_OBJECT_PROPERTIES, Enums.UIObjectProperties.SimCardModule)) {
                items.push({
                    template: TemplateHelper.getContextMenuItem(LocalizationHelper.getLocalizedText(LocalizationHelper.Text.ShowSimCards), ConfigHelper.Icon.SIM_CARD, this.userSessionService),

                    onItemClick: () => {
                        this.systemContextListService.getContextList(Enums.ReferenceType.IdSimCard, options.idReferenceTypes, Enums.ReferenceType.IdLocation)
                    }
                })
            }

            if (this.userSessionService.getLoggedOperator().hasPermission(Activity.ACTION_LIST)
                && !this.userSessionService.getLoggedOperator().hasPermission(Activity.ACTION_MODULE_HIDDEN_UI_OBJECT_PROPERTIES, Enums.UIObjectProperties.ActionModule)) {
                items.push({
                    template: TemplateHelper.getContextMenuItem(LocalizationHelper.getLocalizedText(LocalizationHelper.Text.ShowRecentActions), ConfigHelper.Icon.RECENT_ACTIONS, this.userSessionService),

                    onItemClick: () => {
                        this.systemContextListService.getContextList(Enums.ReferenceType.IdAction, options.idReferenceTypes, Enums.ReferenceType.IdLocation)
                    }
                })
            }

            if (this.userSessionService.getLoggedOperator().hasPermission(Activity.CASHIER_PANEL_VIEW)) {
                items.push({
                    template: TemplateHelper.getContextMenuItem(LocalizationHelper.getLocalizedText(LocalizationHelper.Text.ShowCashierPanel), ConfigHelper.Icon.DOLLAR, this.userSessionService),

                    onItemClick: () => {
                        this.systemContextListService.getContextList(Enums.ReferenceType.IdPaymentModule, options.idReferenceTypes, Enums.ReferenceType.IdLocation)
                    }
                })
            }

            if (this.userSessionService.getLoggedOperator().hasPermission(Activity.CONSUMER_LIST)) {
                items.push({
                    template: TemplateHelper.getContextMenuItem(LocalizationHelper.getLocalizedText(LocalizationHelper.Text.ShowConsumers), ConfigHelper.Icon.CONTACT_MAIL, this.userSessionService),

                    onItemClick: () => {
                        this.systemContextListService.getContextList(Enums.ReferenceType.IdConsumer, options.idReferenceTypes, Enums.ReferenceType.IdLocation)
                    }
                })
            }

            if (this.userSessionService.getLoggedOperator().hasPermission(Activity.TARIFF_LIST)) {
                items.push({
                    template: TemplateHelper.getContextMenuItem(LocalizationHelper.getLocalizedText(LocalizationHelper.Text.ShowTariffs), ConfigHelper.Icon.TARIFF, this.userSessionService),

                    onItemClick: () => {
                        this.systemContextListService.getContextList(Enums.ReferenceType.IdTariff, options.idReferenceTypes, Enums.ReferenceType.IdLocation)
                    }
                })
            }
        }

        if (options.getCorrespondingActionType != null && this.userSessionService.getLoggedOperator().hasPermission(Activity.ACTION_RUN, Enums.ReferenceType.IdLocation)) {
            items.push({
                beginGroup: true,
                template: TemplateHelper.getContextMenuItem(LocalizationHelper.getLocalizedText(LocalizationHelper.Text.RunActions), ConfigHelper.Icon.RUN_ACTIONS, this.userSessionService),

                onItemClick: (args: any) => {
                    options.getCorrespondingActionType(Enums.ReferenceType.IdLocation, args)
                }
            })
        }

        if (options.getLocationsProblems != null && this.userSessionService.getLoggedOperator().hasPermission(Activity.LOCATION_PROBLEM_CONFIRMATION_OP)) {
            items.push({
                beginGroup: true,
                template: TemplateHelper.getContextMenuItem(LocalizationHelper.getLocalizedText(LocalizationHelper.Text.ConfirmExceptions), ConfigHelper.Icon.ACTIONS, this.userSessionService),

                onItemClick: (args: any) => {
                    options.getLocationsProblems()
                }
            })
        }

        if (options.planDelivery != null && this.userSessionService.getLoggedOperator().hasPermission(Activity.LOCATION_PLAN_DELIVERY_TIME_OP)) {
            items.push({
                template: TemplateHelper.getContextMenuItem(LocalizationHelper.getLocalizedText(LocalizationHelper.Text.PlanDelivery), ConfigHelper.Icon.QUERY_BUILDER, this.userSessionService),

                onItemClick: (args: any) => {
                    options.planDelivery()
                }
            })
        }

        if (options.onMassGroupingLocationAssign != null && this.userSessionService.getLoggedOperator().hasPermission(Activity.LOCATION_GROUP_MULTIPLE_ASSIGN_OP)) {
            items.push({
                template: TemplateHelper.getContextMenuItem(LocalizationHelper.getLocalizedText(LocalizationHelper.Text.MassGroupAssigning), ConfigHelper.Icon.SWAP_HORIZ, this.userSessionService),

                onItemClick: (args: any) => {
                    options.onMassGroupingLocationAssign(args)
                }
            })
        }        

        return items
    }

    // #endregion
}

export class LocationContextMenuServiceProvider
    implements ng.IServiceProvider {

    //#region IServiceProvider Implementation 

    public $get = [SYSTEM_CONTEXT_LIST_SERVICE_NAME, USER_SESSION_SERVICE_NAME, function (systemContextListService: SystemContextListService, userSessionService: UserSessionService) {
        return new LocationContextMenuService(systemContextListService, userSessionService)
    }]

    //#endregion
} 
